import {XGroupByType} from "./enums";
import {Klient} from "../model/klient/klient.entity";
import {diagnozyOptions} from "./diagnozy-options";
import {IPostgresInterval} from "@michalrakus/x-react-web-lib/XUtils";

export interface XOptionGroup {
    label: string;
    items: XOption[];
}

export interface XOption {
    label: string;
    code: string;
}

export class UtilsCommon {

    // TODO - move to lib
    private static ENUM_ID: string = "<ENUM_ID>";
    private static DATE_FROM_TOKEN: string = "<DATE_FROM>";
    private static DATE_TO_TOKEN: string = "<DATE_TO>";

    // mame sice v class-e Klient metodu getObecNazov(), ale ked pride klient z frontend-u (alebo pride na frontend), tak mame object literal (data bez funkcii)
    // preto potrebujeme tuto metodu
    static klientObecNazov(klient: Klient): string | null {
        return klient.obec?.nazov ?? klient.obecText;
    }

    static computePercent(partSum: number | null, baseSum: number | null): number | null {
        let percent: number | null = null;
        if (partSum !== null && baseSum !== null) {
            if (baseSum !== 0) {
                const percentNotRounded: number = partSum / baseSum * 100;
                percent = Math.round(percentNotRounded * 100) / 100;
            }
            else {
                // baseSum === 0
                if (partSum === 0) {
                    percent = 0;
                }
            }
        }
        return percent;
    }

    // pri scitavani number cisel som zaznamenal rozdiel v 14. cifre za des. ciarkou, na porovnavanie preto pouzijeme deltu 0.0000000001 (-10 na -10)
    // 1600.15 + 576.95 vracia 2177.10000000000004
    private static delta: number = 10 ** -10;

    static numberCompare(value1: number | null, value2: number | null): (-1 | 0 | 1) | null {
        let result: (-1 | 0 | 1) | null = null;
        if (value1 !== null && value2 !== null) {
            const difference: number = value1 - value2;
            if (Math.abs(difference) < UtilsCommon.delta) {
                result = 0;
            }
            else if (difference < 0) {
                result = -1;
            }
            else {
                // difference > 0
                result = 1;
            }
        }
        return result;
    }

    static numberRound(value: number | null, scale?: number): number | null {
        if (value !== null) {
            scale = scale ?? 2;
            const multiplier: number = 10 ** scale; // 100 for scale = 2
            value = Math.round(value * multiplier) / multiplier;
        }
        return value;
    }

    // TODO - do XUtilsCommon
    static intervalAdd(value1: IPostgresInterval | null, value2: IPostgresInterval | null): IPostgresInterval | null {
        let value: IPostgresInterval | null = null;
        if (value1 !== null && value2 === null) {
            value = value1;
        }
        else if (value1 === null && value2 !== null) {
            value = value2;
        }
        else if (value1 !== null && value2 !== null) {

            let ms = (value1.milliseconds ?? 0) + (value2.milliseconds ?? 0);
            let s = (value1.seconds ?? 0) + (value2.seconds ?? 0);
            let m = (value1.minutes ?? 0) + (value2.minutes ?? 0);
            let h = (value1.hours ?? 0) + (value2.hours ?? 0);
            let d = (value1.days ?? 0) + (value2.days ?? 0);
            let mo = (value1.months ?? 0) + (value2.months ?? 0);
            let y = (value1.years ?? 0) + (value2.years ?? 0);

            // Normalize
            s += Math.floor(ms / 1000);
            ms = ms % 1000;

            m += Math.floor(s / 60);
            s = s % 60;

            h += Math.floor(m / 60);
            m = m % 60;

            d += Math.floor(h / 24);
            h = h % 24;

            y += Math.floor(mo / 12);
            mo = mo % 12;

            value = {
                years: y,
                months: mo,
                days: d,
                hours: h,
                minutes: m,
                seconds: s,
                milliseconds: ms,
            };
        }

        return value;
    }

    // TODO - do XUtilsCommon
    static numberAdd(value1: number | null, value2: number | null, scale?: number): number | null {
        let value: number | null = null;
        if (value1 !== null && value2 === null) {
            value = value1;
        }
        else if (value1 === null && value2 !== null) {
            value = value2;
        }
        else if (value1 !== null && value2 !== null) {
            // operator "+" can produce number like 12.34000000000000001, that's why rounding
            value = UtilsCommon.numberRound(value1 + value2, scale);
        }
        return value;
    }

    // TODO - prehodit do XUtilsCommon
    static minDateIfNull(date: Date | null): Date {
        return date ?? new Date('1000-01-01'); // ak to neda DB, treba skusit pouzit 1970 (constant '0001-01-01' creates date 2001-01-01)
    }

    // TODO - prehodit do XUtilsCommon
    static maxDateIfNull(date: Date | null): Date {
        return date ?? new Date('9999-12-31');
    }

    // TODO - prehodit do XUtilsCommon
    static arrayRemoveItem(array: any[], item: any) {
        const itemIndex: number = UtilsCommon.arrayIndexOf(array, item);
        array.splice(itemIndex, 1);
    }

    // TODO - prehodit do XUtilsCommon
    static arrayReplaceItem(array: any[], item: any, newItem: any) {
        const itemIndex: number = UtilsCommon.arrayIndexOf(array, item);
        array[itemIndex] = newItem;
    }

    // TODO - prehodit do XUtilsCommon
    static arrayIndexOf(array: any[], item: any): number {
        const itemIndex = array.indexOf(item);
        if (itemIndex === -1) {
            throw 'Unexpected error - item not found in list';
        }
        return itemIndex;
    }

    // TODO - prehodit do XUtilsCommon
    static dateDiff(dateOld: Date | null, dateNew: Date | null): number | null {
        let diff: number | null = null;
        if (dateOld !== null && dateNew !== null) {
            diff = Math.round((dateNew.getTime() - dateOld.getTime()) / (1000 * 60 * 60 * 24));
        }
        return diff;
    }

    // TODO - prehodit do XUtilsCommon
    static xGroupByTypeIsDate(xGroupByType: XGroupByType): boolean {
        return UtilsCommon.xGroupByTypeDateTypeList().includes(xGroupByType);
    }

    // TODO - prehodit do XUtilsCommon
    static xGroupByTypeDateTypeList(): XGroupByType[] {
        return [XGroupByType.day, XGroupByType.month, XGroupByType.year];
    }

    // TODO - prehodit do XUtilsCommon - mozno by malo ist do XUtilsConversions
    static xOptionCodeListAsUI(codeList: string[] | null): string {
        codeList = codeList ?? [];
        return codeList.map((code: string) => UtilsCommon.getXOptionByCode(code)?.label ?? code).join(', ');
    }

    // TODO - prehodit do XUtilsCommon aj s XOptionGroup a XOption
    static getXOptionByCode(code: string): XOption | undefined {
        let xOptionFound: XOption | undefined = undefined;
        for (const xOptionGroup of diagnozyOptions) {
            for (const xOption of xOptionGroup.items) {
                if (xOption.code === code) {
                    xOptionFound = xOption;
                }
            }
        }
        return xOptionFound;
    }

    // TODO - move to lib
    static hasDateFromTo(filter: string | null): boolean {
        return filter !== null && filter.indexOf(UtilsCommon.DATE_FROM_TOKEN) !== -1 && filter.indexOf(UtilsCommon.DATE_TO_TOKEN) !== -1;
    }

    // TODO - move to lib
    static replaceEnumId(sqlExp: string, enumIdDB: any) {
        return sqlExp.replaceAll(UtilsCommon.ENUM_ID, enumIdDB);
    }

    // TODO - move to lib
    static replaceDateFromTo(sqlExp: string, dateFromDB: string, dateToDB: string) {
        sqlExp = sqlExp.replaceAll(UtilsCommon.DATE_FROM_TOKEN, dateFromDB);
        return sqlExp.replaceAll(UtilsCommon.DATE_TO_TOKEN, dateToDB);
    }
}
